export function preParsePostFormat (string) {
    return string;
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/locale/pre-post-format.js